import React from 'react'
import { Link } from 'react-router-dom'

import { SpacingWrap, GrayButtonLink, PercentWrap } from './styled'

import { NEW_QUIZ } from 'src/constants/routes'

interface Props {
  matchPercent: number | null
  quizId: number
}
export const QuizMatchValue: React.FC<Props> = ({ matchPercent, quizId }) => {
  if (matchPercent === null) {
    return (
      <SpacingWrap>
        <Link to={NEW_QUIZ.replace(':id', String(quizId))}>
          <GrayButtonLink>Try quiz</GrayButtonLink>
        </Link>
      </SpacingWrap>
    )
  }

  if (matchPercent === -1) {
    return (
      <SpacingWrap>
        <GrayButtonLink secondary>Calculating</GrayButtonLink>
      </SpacingWrap>
    )
  }

  return (
    <SpacingWrap>
      <PercentWrap>{matchPercent}%</PercentWrap>
    </SpacingWrap>
  )
}
